import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaodreno(
  state = INITIAL_STATE,
  action
) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaodreno/FIND_OPERACAOMEDICAOTEMPERATURA':
      case '@operacaodreno/UPDATE_OPERACAOMEDICAOTEMPERATURA':
      case '@operacaodreno/DELETE_OPERACAOMEDICAOTEMPERATURA':
      case '@operacaodreno/STORE_OPERACAOMEDICAOTEMPERATURA':
      case '@operacaodreno/OPERACAOMEDICAOTEMPERATURAS_IN_REQUEST':
      case '@operacaodreno/UPDATE': {
        draft.loading = true;
        break;
      }

      case '@operacaodreno/SUCCESS_REMOVE':
      case '@operacaodreno/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaodreno/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaodrenos;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaodreno/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaodreno;
        break;
      }

      case '@operacaodreno/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}

